export default "__VITE_ASSET__DZYIZioc__"